import React, { useEffect, useState } from 'react'
import { setThemeColorsFromURL } from '../../theme/config'
import { getUrlParams } from '../../utils/helpers/common'
import { useDispatch, useSelector } from 'react-redux'
import { setTheme } from '../../store/slices'
import { ThemeProvider } from 'styled-components'

const CustomThemeHandlerProvider = ({ children }) => {
  const [activeTheme, setActiveTheme] = useState({})
  const params = getUrlParams()
  const theme = params.support_program_type
  const dispatch = useDispatch()
  const { theme: themeState } = useSelector((state) => state.theme)

  useEffect(() => {
    const themeRes = setThemeColorsFromURL(theme || themeState.currentTheme)
    if (theme) {
      dispatch(
        setTheme({
          currentTheme: theme || themeState.currentTheme,
          activeTheme: themeRes,
        }),
      )
    }
    setActiveTheme(themeRes)
  }, [theme])

  return <ThemeProvider theme={activeTheme}>{children}</ThemeProvider>
}

export default CustomThemeHandlerProvider
